import React from 'react';

// @ts-ignore
const InvitePanel = ({ children,isOpen, close }) => {

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={close}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

export default InvitePanel;